import React, { useState, useEffect } from 'react';
import { Stack, Button, TextField } from '@mui/material';
import StepSection from './StepSection';
import FieldAutocomplete from './FieldAutocomplete';
import ChipList from './ChipList';
import { buildLimitsByFieldConfig } from './rankingConfigBuilders';

const defaultLimitsState = {
  enabled: false,
  everyN: 10,
  field: '',
  limit: 5,
  pairs: [],
};

export default function LimitsByFieldStep({ onConfigChange, availableFields }) {
  const [state, setState] = useState(defaultLimitsState);

  useEffect(() => {
    const config = buildLimitsByFieldConfig(state);
    onConfigChange?.({ enabled: state.enabled, config });
  }, [state, onConfigChange]);

  const update = (partial) => setState((prev) => ({ ...prev, ...partial }));

  const addPair = () => {
    const field = (state.field && state.field.trim()) || state.field;
    if (!field || state.pairs.some((p) => p.field === field)) return;
    setState((prev) => ({
      ...prev,
      pairs: [...prev.pairs, { field, limit: Number(prev.limit) || 0 }],
      field: '',
      limit: 5,
    }));
  };

  const chipItems = state.pairs.map((p, i) => ({
    label: `${p.field}:${p.limit}`,
    key: `${p.field}-${i}`,
  }));

  return (
    <StepSection
      title="3) Limits by field"
      enabled={state.enabled}
      onEnabledChange={(enabled) => update({ enabled })}
    >
      <Stack spacing={1}>
        <TextField
          size="small"
          type="number"
          label="Window size (every_n)"
          value={state.everyN}
          onChange={(e) => update({ everyN: e.target.value })}
          inputProps={{ min: 2 }}
          fullWidth
        />
        <Stack direction="row" spacing={1} alignItems="center" flexWrap="wrap">
          <FieldAutocomplete
            options={availableFields}
            value={state.field}
            onChange={(field) => update({ field })}
            label="Field"
            sx={{ minWidth: 140, flex: 1 }}
          />
          <TextField
            size="small"
            type="number"
            label="Limit"
            value={state.limit}
            onChange={(e) => update({ limit: e.target.value })}
            sx={{ width: 90 }}
            inputProps={{ min: 1 }}
          />
          <Button size="small" variant="outlined" onClick={addPair}>
            Add
          </Button>
        </Stack>
        <ChipList
          items={chipItems}
          onDelete={(idx) =>
            setState((prev) => ({
              ...prev,
              pairs: prev.pairs.filter((_, i) => i !== idx),
            }))
          }
        />
      </Stack>
    </StepSection>
  );
}
